<template>
    <div class="global-all">
        <div class="global-content">
            <div class="select-box">
                <div class="title">选择企业</div>
                <div class="select-row">
                    <a-select :value="selectCode" style="width: 400px" @change="handleChange">
                        <a-select-option
                            :value="i.enterpriseId"
                            v-for="(i, index) in enterpriseArr"
                            :key="index"
                        >
                            {{ i.enterpriseId | valTolabel(i) }}
                        </a-select-option>
                    </a-select>
                    <a-button type="primary" class="my-btn" @click="startSelfCheck">
                        开始自检
                    </a-button>
                    <a-button type="primary" class="my-btn" @click="toAddEnterprise">
                        新增企业
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { apiListPC } from '@/api'
    import ajax from '@/api/ajax'

    export default {
        name: 'Select',
        data() {
            return {
                enterpriseArr: [],
                selectCode: '',
            }
        },
        filters: {
            valTolabel: function (value, { fullName }) {
                return fullName
            },
        },
        beforeMount() {
            document.body.style.overflow = 'hidden'
            let that = this
            that.bus.$emit('loading', true)

            ajax(apiListPC.getcomList)
                .then(function (data) {
                    that.bus.$emit('loading', false)
                    that.enterpriseArr = data
                    that.selectCode = data[0] ? data[0].enterpriseId : ''
                    that.handleChange(that.selectCode)
                    if (data.length === 0) {
                        that.$router.push('/Add')
                    }
                })
                .catch(function (err) {
                    that.bus.$emit('loading', false)
                    that.$message.error(err.returnInfo)
                })
        },
        methods: {
            handleChange(value) {
                this.selectCode = value
            },
            startSelfCheck() {
                let that = this
                const { enterpriseId, fullName } = that.enterpriseArr.find(
                    (i) => i.enterpriseId === that.selectCode
                )
                if (!fullName || !enterpriseId) {
                    that.$message.error('请重新选择企业！')
                    return false
                }
                sessionStorage.setItem('enterpriseId', enterpriseId)
                sessionStorage.setItem('fullName', fullName)

                that.$router.push({
                    name: 'Type',
                    query: {
                        enterpriseId,
                        fullName,
                    },
                })
            },
            toAddEnterprise() {
                this.$router.push('/Add')
            },
        },
    }
</script>

<style lang="less" type="text/less" scoped>
    .global-all {
        background: url('../../../static/images/add-bg.png') no-repeat;
        background-size: cover;
        padding-top: 20px;
        min-height: calc(100vh - 70px);
        .global-content {
            box-shadow: none;
            padding-top: 0px;

            .select-box {
                width: 800px;
                margin: 180px auto 0;

                .title {
                    width: 100%;
                    text-align: center;
                    font-size: 30px;
                    /*color: #333;*/
                    color: #fff;
                    font-weight: 700;
                }

                .select-row {
                    display: flex;
                    justify-content: center;
                    margin-top: 20px;
                    /deep/.ant-select-selection--single {
                        height: 42px;
                        font-size: 16px;

                        .ant-select-selection__rendered {
                            line-height: 42px;
                        }
                    }

                    .my-btn {
                        background-color: #fff;
                        border-color: #fff;
                        color: #5867dd;
                        margin-left: 10px;
                        height: 42px;
                        width: 120px;
                        font-size: 16px;
                    }
                }
            }
        }
    }
</style>
